import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const VolvoBusRental = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Volvo Bus Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Volvo Luxury Bus Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          When it comes to premium group travel, nothing matches the elegance and performance of a Volvo coach. 
          At <strong>eTravo</strong>, we offer well-maintained, fully air-conditioned Volvo buses that are ideal for 
          long-distance journeys, intercity travel, corporate tours, and destination weddings.
        </p>

        <h2 style={styles.subHeader}>Perfect For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Outstation Group Travel</li>
          <li style={styles.listItem}>Destination Weddings</li>
          <li style={styles.listItem}>VIP Corporate Logistics</li>
          <li style={styles.listItem}>Religious Tours & Pilgrimages</li>
          <li style={styles.listItem}>Luxury Tourist Transport</li>
        </ul>

        <h2 style={styles.subHeader}>Volvo Bus Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Air Suspension for smooth rides</li>
          <li style={styles.listItem}>Push-back recliner seats (40–45 capacity)</li>
          <li style={styles.listItem}>Centralized air-conditioning with individual vents</li>
          <li style={styles.listItem}>Spacious legroom and overhead luggage racks</li>
          <li style={styles.listItem}>Large boot space for heavy baggage</li>
          <li style={styles.listItem}>Entertainment system with mic and music</li>
        </ul>

        <h2 style={styles.subHeader}>Why Choose eTravo Volvo Service?</h2>
        <p style={styles.paragraph}>
          Our luxury Volvo buses are perfect for high-comfort travel over long hours. We provide experienced chauffeurs, 
          24x7 customer support, clean and sanitized vehicles, and GPS tracking. With <strong>eTravo</strong>, you travel 
          worry-free, knowing everything is managed professionally.
        </p>

       

        <h2 style={styles.subHeader}>Book Your Volvo Now</h2>
        <p style={styles.paragraph}>
          Make your journey comfortable and classy with eTravo’s Volvo coach rental. 
          Get in touch today for flexible booking options, route customization, and best-in-class pricing.
        </p>
      </div>
    </>
  );
};

export default VolvoBusRental;
